// extracted by mini-css-extract-plugin
export default {"dot-spinner":"DotSpinner_dot-spinner__mdJm5","dot":"DotSpinner_dot__Z3o+0","pulse":"DotSpinner_pulse__vFOwJ"};